//#region SORTING OPTIONS
import { SortOption } from "./sorting";

export const orderSortingOptions: SortOption[] = [
  { id: 0, value: null, label: "none", current: false, direction: null },
  {
    id: 1,
    value: "promo_id",
    label: "promo code ascending",
    current: false,
    direction: "asc",
  },
  {
    id: 2,
    value: "promo_id",
    label: "promo code descending",
    current: false,
    direction: "desc",
  },
  {
    id: 3,
    value: "order_status",
    label: "order status ascending",
    current: false,
    direction: "asc",
  },
  {
    id: 4,
    value: "order_status",
    label: "order status descending",
    current: false,
    direction: "desc",
  },
  {
    id: 5,
    value: "updated_at",
    label: "last updated ascending",
    current: false,
    direction: "asc",
  },
  {
    id: 6,
    value: "updated_at",
    label: "last updated descending",
    current: false,
    direction: "desc",
  },
  {
    id: 7,
    value: "shipping_date",
    label: "shipping date ascending",
    current: false,
    direction: "asc",
  },
  {
    id: 8,
    value: "shipping_date",
    label: "shipping date descending",
    current: false,
    direction: "desc",
  },
];

export const storeSortingOptions: SortOption[] = [
  { id: 0, value: null, label: "none", current: false, direction: null },
  {
    id: 1,
    value: "external_store_id",
    label: "store number ascending",
    current: false,
    direction: "asc",
  },
  {
    id: 2,
    value: "external_store_id",
    label: "store number descending",
    current: false,
    direction: "desc",
  },
  {
    id: 3,
    value: "country_name",
    label: "country name ascending",
    current: false,
    direction: "asc",
  },
  {
    id: 4,
    value: "country_name",
    label: "country name descending",
    current: false,
    direction: "desc",
  },
  {
    id: 5,
    value: "city",
    label: "city name ascending",
    current: false,
    direction: "asc",
  },
  {
    id: 6,
    value: "city",
    label: "city name descending",
    current: false,
    direction: "desc",
  },
  {
    id: 7,
    value: "updated_at",
    label: "last updated ascending",
    current: false,
    direction: "asc",
  },
  {
    id: 8,
    value: "updated_at",
    label: "last updated descending",
    current: false,
    direction: "desc",
  },
  {
    id: 9,
    value: "store_name",
    label: "store name ascending",
    current: false,
    direction: "asc",
  },
  {
    id: 10,
    value: "store_name",
    label: "store name descending",
    current: false,
    direction: "desc",
  },
];
//#endregion

//#region MODALS
export const CREATE_OR_UPDATE_INSTORE_THEMES_MODAL =
  "CREATE_OR_UPDATE_INSTORE_THEMES_MODAL";
export const CREATE_OR_UPDATE_INSTORE_TYPES_MODAL =
  "CREATE_OR_UPDATE_INSTORE_TYPES_MODAL";
export const UPDATE_SUBORDER_TRACKINGFORM_MODAL =
  "UPDATE_SUBORDER_TRACKINGFORM_MODAL";
export const INSTORE_ORDER_WITHOUT_EXTRAS_SURE =
  "INSTORE_ORDER_WITHOUT_EXTRAS_SURE";
export const UPLOAD_DATA_FOR_INSTORE_TEMPLATE =
  "UPLOAD_DATA_FOR_INSTORE_TEMPLATE";
export const UPLOAD_DATA_OVERWRITE_TRANSMART =
  "UPLOAD_DATA_OVERWRITE_TRANSMART";
export const CREATE_OR_UPDATE_INSTORE_ORDER = "CREATE_OR_UPDATE_INSTORE_ORDER";
export const INSTORE_ORDER_LINE_DELETE_SURE = "INSTORE_ORDER_LINE_DELETE_SURE";
export const IMPERSONATE_STORE_FORMAT_MODAL = "IMPERSONATE_STORE_FORMAT_MODAL";
export const PICK_INSTORE_ORDER_TYPE_MODAL = "PICK_INSTORE_ORDER_TYPE_MODAL";
export const CREATE_OR_UPDATE_STOREFORMAT = "CREATE_OR_UPDATE_STOREFORMAT";
export const DELETE_PRODUCT_VERSION_SURE = "DELETE_PRODUCT_VERSION_SURE";
export const UPDATE_TEMPLATE_SPECS_MODAL = "UPDATE_TEMPLATE_SPECS_MODAL";
export const CREATE_TEMPLATE_SPECS_MODAL = "CREATE_TEMPLATE_SPECS_MODAL";
export const STORE_ADDRESS_MODAL_SAFETY = "STORE_ADDRESS_MODAL_SAFETY";
export const CREATE_ORDERLINE_ROW_MODAL = "CREATE_ORDERLINE_ROW_MODAL";
export const CREATE_OR_UPDATE_LANGUAGE = "CREATE_OR_UPDATE_LANGUAGE";
export const DELETE_INSTORE_ORDER_SURE = "DELETE_INSTORE_ORDER_SURE";
export const DELETE_INSTORE_THEME_SURE = "DELETE_INSTORE_THEME_SURE";
export const CANCEL_INSTORE_ORDER_SURE = "CANCEL_INSTORE_ORDER_SURE";
export const COPY_TEMPLATE_SPECS_MODAL = "COPY_TEMPLATE_SPECS_MODAL";
export const CREATE_TEMPLATE_ROW_MODAL = "CREATE_TEMPLATE_ROW_MODAL";
export const ADD_TRACK_AND_TRACE_MODAL = "ADD_TRACK_AND_TRACE_MODAL";
export const CONFIRM_BASKET_PERSO_MODAL = "CONFIRM_BASKET_PERSO_MODAL";
export const DELETE_INSTORE_TYPE_SURE = "DELETE_INSTORE_TYPE_SURE";
export const CHOOSE_PICKLIST_SUPPLIER = "CHOOSE_PICKLIST_SUPPLIER";
export const ADD_PERSO_VARIABLE_MODAL = "ADD_PERSO_VARIABLE_MODAL";
export const STORE_FORM_MODAL_SAFETY = "STORE_FORM_MODAL_SAFETY";
export const CREATE_OR_UPDATE_PROMO = "CREATE_OR_UPDATE_PROMO";
export const ADD_PERSO_VALUES_MODAL = "ADD_PERSO_VALUES_MODAL";
export const CREATE_OR_UPDATE_STORE = "CREATE_OR_UPDATE_STORE";
export const CREATE_OR_UPDATE_USER = "CREATE_OR_UPDATE_USER";
export const UPLOAD_DATA_FOR_STORE = "UPLOAD_DATA_FOR_STORE";
export const UPLOAD_DATA_FOR_PROMO = "UPLOAD_DATA_FOR_PROMO";
export const CHANGE_STORE_COMMENT = "CHANGE_STORE_COMMENT";
export const DELETE_TEMPLATE_SURE = "DELETE_TEMPLATE_SURE";
export const DELETE_PRODUCT_SURE = "DELETE_PRODUCT_SURE";
export const DELETE_PROJECT_SURE = "DELETE_PROJECT_SURE";
export const STORE_ADDRESS_MODAL = "STORE_ADDRESS_MODAL";
export const CLEAR_PROJECT_SURE = "CLEAR_PROJECT_SURE";
export const SHOW_SUBORDER_INFO = "SHOW_SUBORDER_INFO";
export const CROSS_BASKET_BLOCK = "CROSS_BASKET_BLOCK";
export const SEARCH_STORE_MODAL = "SEARCH_STORE_MODAL";
export const CROSS_PROMO_BLOCK = "CROSS_PROMO_BLOCK";
export const ADD_COMMENT_MODAL = "ADD_COMMENT_MODAL";
export const CANCEL_ORDER_SURE = "CANCEL_ORDER_SURE";
export const DELETE_STORE_SURE = "DELETE_STORE_SURE";
export const DELETE_USER_SURE = "DELETE_USER_SURE";
export const CONFIRM_BULK_ORDERS = "CONFIRM_BULK_ORDERS";
export const CONFIRM_BULK_INSTORE_ORDERS = "CONFIRM_BULK_INSTORE_ORDERS";
export const EXPORT_BULK_INSTORE_ORDERS = "EXPORT_BULK_INSTORE_ORDERS";
export const CONFIRM_PICKLIST_DOWNLOAD = "CONFIRM_PICKLIST_DOWNLOAD";
//#endregion

//#region ADDRESS TYPES
export const BILLING_ADDRESS_CODE = 1;
export const DELIVERY_ADDRESS_CODE = 2;
//#endregion

//#region CONSTANT VARIABLES
export const MAX_SPREADSHEET_SHEET_NAME_LENGTH = 31;
export const NONE_OPTION_VALUE = "none";
// Bulk actions only ask for confirmation above this many items.
export const BULK_CONFIRM_THRESHOLD = 5;
//#endregion
